import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { PageType } from 'src/app/analytics/newrelic/enums/PageType';
import { showHeroByUrl } from '../../utils/cardsCarouselUtils';
import { TabService } from '../tabs/tab.service';

@Injectable({
  providedIn: 'root',
})
export class ScreenService {
  searchItemPosition = 'NA';
  private previouscreen: string;
  private currentscreen: string;
  private searchLink: string;
  private history: string[] = [];
  private _heroVisibility = new BehaviorSubject<boolean>(false);
  private navigation$ = new BehaviorSubject({
    previousScreen: undefined,
    currentscreen: undefined,
    tabId: undefined,
    tabName: undefined,
    type: undefined,
    tabs: undefined,
  });

  get currentScreen(): string {
    return this.currentscreen;
  }

  set currentScreen(value: string) {
    this.currentscreen = value;
  }

  set previousScreen(value: string) {
    this.previouscreen = value;
  }

  get previousScreen(): string {
    return this.previouscreen;
  }

  get searchlink(): string {
    return this.searchLink;
  }

  set searchlink(value: string) {
    this.searchLink = value;
  }

  get heroVisibility(): Observable<boolean> {
    return this._heroVisibility.asObservable();
  }

  constructor(private router: Router, private tabService: TabService, private activatedRoute: ActivatedRoute) {
    this.navigation$.asObservable().subscribe((result) => {
      if (result.type === 'tab') {
        this.tabService.currentTabId = result.tabId;
        this.tabService.currentTabName = result.tabName;
      } else {
        this.setCurrentScreen(result.currentscreen);
      }
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this._heroVisibility.next(showHeroByUrl(event.url));
        this.history?.push(event.urlAfterRedirects);
        let pageId =
          this.activatedRoute?.snapshot?.firstChild?.data?.pageID || this.activatedRoute?.firstChild?.snapshot?.firstChild?.data?.pageID;
        if (this.router.url.includes('epg')) {
          pageId = PageType.Epg;
        }
        this.setCurrentScreen(pageId);
      }
    });
  }

  setCurrentScreen(currentScreen: string): void {
    this.previouscreen = this.currentscreen;

    if (currentScreen === PageType.Browse) {
      this.currentscreen = this.tabService.currentTabName;
    } else {
      this.currentscreen = currentScreen;
    }
  }

  hideHero() {
    this._heroVisibility.next(false);
  }
}
